<template>
  <div class="progress-bar-container">
    <div
      class="progress-bar-wrapper"
      :style="{ width: percentage + '%', backgroundColor: getBarColor() }"
    >
      <div class="progress-bar" />
    </div>
    <span
      class="progress-text"
      :style="{ color: getTextColor(), fontWeight: 'bold' }"
    >
      {{ percentage }}%
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100 // 限制在 0 到 100 范围内
    },
    isError: {
      type: Boolean,
      default: false // 是否异常
    }
  },
  methods: {
    getBarColor() {
      if (this.isError) {
        return '#f56c6c' // 红色（异常）
      } else if (this.percentage === 100) {
        return '#67c23a' // 绿色（已完成）
      } else {
        return '#409eff' // 蓝色（进行中）
      }
    },
    getTextColor() {
      if (this.isError || this.percentage === 100) {
        return '#fff' // 红色和绿色状态，文字为白色
      } else {
        return '#000' // 蓝色状态，文字为黑色
      }
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.progress-bar-container {
  width: 200px;
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 5px;
  height: 20px;
  position: relative;
  overflow: hidden;
}

/* 进度条外部容器，用于控制宽度 */
.progress-bar-wrapper {
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
}

/* 进度条本体 */
.progress-bar {
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.5) 25%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.5) 75%
  );
  background-size: 200% 100%;
  animation: flowing 3s linear infinite; /* 涌动动画 */
}

/* 动画效果 */
@keyframes flowing {
  from {
    background-position: 0% 0;
  }
  to {
    background-position: 200% 0;
  }
}

/* 进度文字 */
.progress-text {
  position: absolute;
  right: 10px;
  font-size: 12px;
  z-index: 1;
  animation: flashing 3s infinite; /* 数字闪烁动画 */
}

/* 数字闪烁动画 */
@keyframes flashing {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
